import React, { useEffect, useRef, useState } from "react";
import RepeatImage from "../../../assets/svg/repeat.svg";
import DownArrow from "../../../assets/svg/downward-arrow.svg";
import DownArrowWhite from "../../../assets/svg/downward-arrow-white.svg";
import UpArrow from "../../../assets/svg/upward-arrow.svg";
import Downlaod from "../../../assets/svg/download.svg";
import DownwardArrow from "../../../assets/svg/down-arrow.svg";
import ShareWhite from "../../../assets/svg/share-white.svg";
import LinearArrow from "../../../assets/svg/LinearArrow.svg";
import OtherDownArrow from "../../../assets/svg/DownArrow.svg";
import OtherUpArrow from "../../../assets/svg/UpArrow.svg";
import DownloadCloud from "../../../assets/svg/DownloadCloud.svg";
import CopyLink from "../../../assets/svg/CopyIcon.svg";
import Stepper from "../Stepper";
import Progress from "../Progress";
import TX_PROGRESS from "../../../constants";
import {
  downloadDocumentHistoryPage,
  downloadOtherKycDocx,
  getDownlaodPAN,
  // getComments,
  getTransactionData,
  getTransactionDocx,
  getTransactionRemarks,
  postNewUTRNum,
  shareHistoryPageDocs,
  uploadDocs,
  // shareHistoryPageDocs,
} from "../../../services/history";
import { ToastContainer, toast } from "react-toastify";
import useClickOutside from "../../../hooks/useClickOutside";
import {
  historyPageEsignModal,
  historyPageSelectedTransaction,
  remitterID,
  selectedTransactionID,
  selectedTransactionRejectionStatus,
  transactionId,
} from "../../../store";
import { RecoilState, useRecoilState, useRecoilValue } from "recoil";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { downloadDocumentHistory } from "../../../utils";
import Status from "../Status";
import { InfoIcon } from "../../../assets/Icons";
import ErrorField from "../ErrorField";
import Button from "../Button";
import refreshIcon from "../../../assets/svg/refreshIcon.svg";
import Rotator from "../Rotater";

// Define a type for the transaction data
type TabKeys = "Online" | "Flywire" | "Offline" | "Travel Card" | "Convera";

type TransactionList = {
  remitterName: string;
  recipientName: string;
  sourceAmount: string | number;
  destinationCurrency: string | number;
  destinationAmount: string | number;
  fxRate: string | number;
  modeOfTransaction: string;
  status: any;
  transactionNumber: string;
  createdOn: string;
  userKey: string;
  referenceNumber: string;
  vendorCode: string;
  partner: string;
  baseCurrency: string;
  recipientReceive: number | string;
  userSend: number | string;
  id: number;
  transactionCreationDate: any;
  converaReferenceId: any;
  sourceCurrency: any;
  dollarEquivalent?: number;
  reportTitle?: any;
  reportDescription?: any;
  referrerVendor?: any;
};

interface User {
  vendor_key?: string;
}

type TransactionDocsProps = [
  {
    docName: string;
    isOsv: boolean;
    idDoc: number | string;
    idNumber: string | null | number;
    createdOn: string;
    areLogsPresent: boolean;
    docPath: string;
  }
];

interface CommentsProps {
  remark: any;
  createdOn: string;
  email: number;
}

interface CommentsProps {
  remark: any;
  createdOn: string;
  email: number;
}

interface TimerProps {
  initialRemainingTime: number;
}

type TransactionData = {
  declarationDetails: {
    shouldTakeCover: boolean;
    onBoardedBy: string;
    transferType: null | string;
    isDocsSufficient: boolean;
    branch: null;
    dualTransactionNumber: "" | string;
    isPaymentReceived: boolean;
    lanNumber: null | string;
    vendorCode: string;
    utrNumber: string;
  };
  paymentConfirmationManuallyUploadedByUser: boolean;
  purpose: string;
  otherDetails: {
    ckycId: null;
    isCancelTransaction: boolean;
    purposeOfPayment: string;
    isAwaitingPayment: boolean;
    isFormReceipt: boolean;
    platform: string;
    isAddedToMassPay: boolean;
    sourceOfIncome: string;
    purposeCode: string;
  };
  statusToBeShown: string;
  kycDocs: {
    userDocuments: [
      {
        docName: string;
        isOsv: boolean;
        idDoc: number | string;
        idNumber: string;
        createdOn: string;
        areLogsPresent: boolean;
        docPath: string;
      }
    ];
    isVerified: boolean;
    userKey: string;
  };
  transactionDocs: TransactionDocsProps;
  id: number | string;
  paymentBreakUp: {
    amountSent: string | number;
    bankFee: number | string;
    tcs: string | number;
    conversionAmount: number | string;
    rateApplied: number;
    sourceCurrency: string;
    totalPay: number;
    ibr: number;
    nostroCharges: number;
    vendorMargin: number;
    theyReceive: number;
    convenienceFee: number;
  };
  remitterAndBeneDetails: {
    remitterDob: string;
    remitterAddress: string;
    remitterCityAndState: string;
    isRemitterPanAndAadharLinked: boolean;
    swiftCode: string;
    beneficiaryBankAddress: string;
    beneficiaryBankAccountCountry: string;
    hasLinkBeenSent: boolean;
    remitterEmail: string;
    beneficiaryName: string;
    beneficiaryBankName: string;
    beneficiaryRelationShip: string;
    remitterCommunicationAddress: string;
    ibanCode: string;
    isBene: boolean;
    remitterPhoneNumber: number | string;
    remitterName: string;
    beneficiaryCountryOfResidence: string;
    beneficiaryBankAccountNumber: string;
    link: string;
    hasRemitterSigned: boolean;
  };
  paymentDetails: {
    payeeName: string;
    utrNumbers: string;
    modeOfPayment: string;
    paymentId: string | number;
    bankName: string;
    accountNumber: string;
  };
  status: string;
  remainingTime: number;
};

type DetailProps = {
  title: string;
  show?: boolean;
  details: {
    label: string | "";
    value: string | React.ReactNode;
    important?: boolean;
  }[];
};

type DetailsMultipleDataProps = {
  title?: string;
  show?: boolean;
  details?: {
    label: string | "";
    value: string | React.ReactNode;
    important?: boolean;
    show?: boolean;
  }[];
  data?: DetailProps[];
};

type TransactionExtensionProps = {
  trxnData: TransactionData;
};

type TransactionDataProps = {
  trxnData: any;
  selectedTransaction: string;
  selectedTab: string;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsCancelModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isDownloadDocxButtonClicked: boolean;
  setIsDownloadDocxButtonClicked: React.Dispatch<React.SetStateAction<boolean>>;
  isShareButtonClicked: boolean;
  setIsShareButtonClicked: React.Dispatch<React.SetStateAction<boolean>>;
};

type NewHistoryCardTransactionProps = {
  isOpen: boolean;
  transactionsList: any;
  handleAccordionClick: (id: string) => void;
  selectedTransaction: string;
  selectedTab: string;
  loading: any;
  setLoading: any
};

type NewHistoryCardProps = {
  transactions: any;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedTab: string;
  setIsCancelModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  pagination: {
    page: number;
    size: number;
    ascending: boolean;
    totalElements: number;
    totalPages: number;
  };
};

const getDate = (date: string) => {
  const formattedDate =
    new Date(date).toLocaleDateString() +
    "," +
    new Date(date).toLocaleString("en-US", {
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    });

  return formattedDate.toString();
};

export const NewHistoryCardTransaction: React.FC<
  NewHistoryCardTransactionProps
> = ({
  transactionsList,
  isOpen,
  handleAccordionClick,
  selectedTransaction,
  selectedTab,
  loading
}) => {
    const {
      remitterName,
      recipientName,
      sourceAmount,
      destinationCurrency,
      destinationAmount,
      fxRate,
      modeOfTransaction,
      // status,
      transactionNumber,
      createdOn,
      userKey,
      referenceNumber,
      recipientReceive,
      vendorCode,
      userSend,
      id,
      baseCurrency,
      partner,
      transactionCreationDate,
      converaReferenceId,
      sourceCurrency,
      dollarEquivalent,
      reportTitle,
      reportDescription,
      referrerVendor
    } = transactionsList as TransactionList;
    const status: keyof typeof TX_PROGRESS =
      transactionsList && (transactionsList.status as keyof typeof TX_PROGRESS);
    const otherStatus =
      selectedTab !== "Convera"
        ? transactionsList?.status
        : `${transactionsList?.status || ""} | ${reportTitle || ""} | ${reportDescription || ""}`;
    const [, setRemitterId] = useRecoilState(remitterID);

    if (selectedTab === "Online") {
      return (
        <div className="grid grid-cols-8 w-full px-2" onClick={() => {
          handleAccordionClick(transactionNumber);
          setRemitterId(userKey);
        }}>
          <p
            id="Transaction-Date"
            className="transaction-list-design text-center"
          >
            {getDate(createdOn)}
          </p>
          <p id="Transaction-id" className="transaction-list-design text-center">
            {transactionNumber}
          </p>
          <p id="Remitter-Name" className="transaction-list-design text-center">
            {remitterName}
          </p>
          <p id="Remitter-Name" className="transaction-list-design text-center">
            {recipientName}
          </p>
          <p
            id="Transaction-Amount"
            className="transaction-list-design text-center whitespace-nowrap ml-4"
          >
            <span>{sourceAmount?.toLocaleString("en-IN")} INR</span>
            {/* <img className="px-2" src={RepeatImage} /> */}
            {" "} →{" "}
            <span>{destinationAmount?.toLocaleString("en-US") + " " + destinationCurrency}</span>
          </p>
          <p id="Market-rate" className="transaction-list-design text-center">
            {fxRate}
          </p>
          {/* <p id="Payment-Mode" className="transaction-list-design text-center">
            {modeOfTransaction}
          </p> */}
          <p
            id="Current-Status"
            className="transaction-list-design text-center font-bold flex items-center w-full pl-[26%]"
          >
            <div className="w-full flex flex-wrap">
              <p className="text-xs max-w-[200px] whitespace-normal truncate  hover:overflow-visible">{status}</p>
              <div className="pt-1 w-full">
                <Progress
                  progressCompleted={TX_PROGRESS[status]?.progressCompleted}
                  progressColor={TX_PROGRESS[status]?.progressColor}
                  progressContainerClassname="w-full"
                />
              </div>
            </div>
          </p>
          <div id="Vendor-code" className="transaction-list-design text-center flex items-center pl-[40%]">
            <p className="min-w-[46px]">
              {referrerVendor || "N/A"}
            </p>
            <div
              id="Drop-down-icon"
              className="flex items-center justify-center pl-8 cursor-pointer"
              onClick={() => {
                handleAccordionClick(transactionNumber);
                setRemitterId(userKey);
              }}
            >
              {loading && transactionNumber === selectedTransaction && !isOpen ? (
                <Rotator />
              ) : (
                <img
                  src={
                    isOpen && transactionNumber === selectedTransaction
                      ? UpArrow
                      : DownArrow
                  }
                  alt="toggle"
                />
              )}
            </div>
          </div>
        </div>
      );
    }
    if (selectedTab === "Flywire") {
      return (
        <div className="grid grid-cols-6 gap-6 px-6 pl-[5%]">
          <p id="Transaction-Date" className="col-span-1 transaction-list-design">
            {getDate(createdOn)}
          </p>
          <p id="Transaction-Date" className="col-span-1 transaction-list-design pl-[8%]">
            {referenceNumber || ""}
          </p>
          <p id="Transaction-Date" className="transaction-list-design col-span-1 pl-[24%]">
            {recipientReceive?.toLocaleString("en-US") || "" + " " + destinationCurrency || ""}
          </p>
          <p id="Transaction-Date" className="transaction-list-design col-span-1 pl-[28%]">
            {dollarEquivalent?.toFixed(2) || "N/A"}
          </p>
          <p id="Transaction-Date" className="transaction-list-design col-span-1 pl-[28%]">
            {vendorCode || "N/A"}
          </p>
          <p
            id="Transaction-Status"
            className="transaction-list-design col-span-1 w-full pl-[20%] text-center"
          >
            <div className="min-w-28">
              <Status status={otherStatus} />
            </div>
          </p>
        </div>
      );
    }
    if (selectedTab === "Offline" || selectedTab === "Travel Card") {
      return (
        <div className="grid grid-cols-7 gap-6 px-6 pl-[4%]" onClick={() => {
          handleAccordionClick(id?.toString());
          setRemitterId(userKey);
          // setLoading(true); 
        }}>
          <p id="Transaction-Date" className="col-span-1 transaction-list-design">
            {getDate(createdOn)}
          </p>
          <p id="Transaction-id" className="col-span-1 transaction-list-design">
            {transactionNumber}
          </p>
          <p
            id="Transaction-Reference-Number"
            className="col-span-1 transaction-list-design pl-[20%]"
          >
            {remitterName || ""}
          </p>
          <div
            id="Transaction-Reciepient-Recieve"
            className="transaction-list-design col-span-1 flex items-center ml-[-5%]"
          >
            <p>{userSend?.toLocaleString("en-IN") + " " + baseCurrency}</p>
            <img src={LinearArrow} className="px-2" />
            <p>{recipientReceive?.toLocaleString("en-US") + " " + destinationCurrency}</p>
          </div>
          <p
            id="Transaction-Vendor"
            className="transaction-list-design col-span-1 pl-[20%]"
          >
            {vendorCode || ""}
          </p>
          <p
            id="Transaction-Partner"
            className="transaction-list-design col-span-1 pl-[20%]"
          >
            {partner || ""}
          </p>
          <div
            id="Drop-down-icon"
            className="pl-4 flex items-center justify-center cursor-pointer"
            onClick={() => {
              handleAccordionClick(id?.toString());
              setRemitterId(userKey);
              // setLoading(true); 
            }}
          >
            <div className="min-w-28">
              <Status status={otherStatus} />
            </div>

            {loading && id?.toString() === selectedTransaction && !isOpen ? (
              // <div className="w-5 h-5 rounded-full bg-gray-300 animate-pulse" />
              <Rotator />
            ) : (
              <img
                src={
                  isOpen && id?.toString() === selectedTransaction
                    ? OtherUpArrow
                    : OtherDownArrow
                }
                alt="toggle"
              />
            )}
          </div>

        </div>
      );
    }
    if (selectedTab === "Flywire") {
      return (
        <div className="grid grid-cols-5 gap-6 px-6">
          <p id="Transaction-Date" className="col-span-1 transaction-list-design">
            {getDate(createdOn)}
          </p>
          <p id="Transaction-Date" className="col-span-1 transaction-list-design">
            {referenceNumber || ""}
          </p>
          <p id="Transaction-Date" className="transaction-list-design col-span-1">
            {recipientReceive?.toLocaleString("en-US") || "" + " " + destinationCurrency || ""}
          </p>
          <p id="Transaction-USD-Equivalent" className="transaction-list-design col-span-1">
            {dollarEquivalent?.toFixed(2) || ""}
          </p>
          <p id="Transaction-Date" className="transaction-list-design col-span-1">
            {vendorCode || ""}
          </p>
          <p
            id="Transaction-Status"
            className="transaction-list-design col-span-1 w-fit"
          >
            <div className="min-w-28">
              <Status status={otherStatus} />
            </div>
          </p>
        </div>
      );
    }
    if (selectedTab === "Offline" || selectedTab === "Travel Card") {
      return (
        <div className="grid grid-cols-6 px-6" onClick={() => {
          handleAccordionClick(id?.toString());
          setRemitterId(userKey);
          // setLoading(true); 
        }}>
          <p id="Transaction-Date" className="col-span-1 transaction-list-design">
            {getDate(createdOn)}
          </p>
          <p
            id="Transaction-Reference-Number"
            className="col-span-1 transaction-list-design"
          >
            {remitterName || ""}
          </p>
          <div
            id="Transaction-Reciepient-Recieve"
            className="transaction-list-design col-span-1 flex items-center"
          >
            <p>{(userSend ? userSend?.toLocaleString("en-IN") : "--") + " " + (baseCurrency ?? "")}</p>
            <img src={LinearArrow} className="px-2" alt="arrow" />
            <p>{(recipientReceive ? recipientReceive?.toLocaleString("en-US") : "--") + " " + (destinationCurrency ?? "")}</p>
          </div>
          <p
            id="Transaction-Vendor"
            className="transaction-list-design col-span-1"
          >
            {vendorCode || ""}
          </p>
          <p
            id="Transaction-Partner"
            className="transaction-list-design col-span-1"
          >
            {partner || ""}
          </p>
          <div
            id="Transaction-Status"
            className="col-span-1 flex items-center text-center"
            onClick={() => {
              handleAccordionClick(id?.toString());
              setRemitterId(userKey);
            }}
          >
            <div className="min-w-28">
              <Status status={otherStatus} />
            </div>
            {loading && id?.toString() === selectedTransaction && !isOpen ? (
              // <div className="w-5 h-5 rounded-full bg-gray-300 animate-pulse" />
              <Rotator />
            ) : (
              <img
                src={
                  isOpen && id?.toString() === selectedTransaction
                    ? OtherUpArrow
                    : OtherDownArrow
                }
                alt="toggle"
              />
            )}
          </div>
        </div>
      );
    }
    if (selectedTab === "Convera") {
      return (
        <div className="grid grid-cols-7 pl-7" onClick={() => {
          handleAccordionClick(converaReferenceId ?? converaReferenceId);
        }}>
          <p id="Transaction-Date" className="col-span-1 transaction-list-design pl-4">
            {getDate(transactionCreationDate)}
          </p>
          <p id="Transaction-id" className="col-span-1 transaction-list-design pl-12">
            {converaReferenceId || "N/A"}
          </p>
          <p
            id="remitterName"
            className="col-span-1 transaction-list-design pl-14"
          >
            {remitterName || "N/A"}
          </p>
          <div
            id="Transaction-Reciepient-Recieve"
            className="transaction-list-design col-span-1 flex items-center pl-3"
          >
            <p>{userSend?.toLocaleString("en-IN") + " " + sourceCurrency || ""}</p>
            <img src={LinearArrow} className="px-2" />
            <p>{recipientReceive?.toLocaleString("en-US") + " " + destinationCurrency || ""}</p>
          </div>
          <p
            id="Transaction-Vendor"
            className="transaction-list-design col-span-1 pl-14"
          >
            {vendorCode || ""}
          </p>
          <p
            id="Transaction-Partner"
            className="transaction-list-design col-span-1 pl-12"
          >
            {partner || "Convera"}
          </p>
          <div
            id="Transaction-Status"
            className="col-span-1 flex items-center text-center -ml-4 cursor-pointer"
            onClick={() => {
              handleAccordionClick(converaReferenceId ?? converaReferenceId);
            }}
          >
            <div className="min-w-48">
              <Status status={otherStatus} selectedTab={selectedTab} />
            </div>
            {loading && id?.toString() === selectedTransaction && !isOpen ? (
              // <div className="w-5 h-5 rounded-full bg-gray-300 animate-pulse" />
              <Rotator />
            ) : (
              <img
                src={
                  isOpen && converaReferenceId?.toString() === selectedTransaction
                    ? OtherUpArrow
                    : OtherDownArrow
                }
                alt="toggle"
              />
            )}
          </div>
        </div>
      );
    }
    return null;
  };

// main component that renders whole history page component.
const NewHistoryCard: React.FC<NewHistoryCardProps> = ({
  transactions,
  setIsModalOpen,
  pagination,
  selectedTab,
  setIsCancelModalOpen,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedTransaction, setSelectedTransaction] = useRecoilState<string>(
    historyPageSelectedTransaction
  );
  const [loading, setLoading] = React.useState(false);
  const [trxnData, setTrxnData] = React.useState<any>({});
  const [isDownloadDocxButtonClicked, setIsDownloadDocxButtonClicked] =
    useState(false);
  const [isShareButtonClicked, setIsShareButtonClicked] = useState(false);

  const handleAccordionClick = (transactionId: string | number | undefined) => {
    if (!transactionId) return;

    const id = transactionId.toString();

    if (selectedTransaction === id) {
      setSelectedTransaction("");
      setIsOpen(false);
    } else {
      setSelectedTransaction(id);
      setIsOpen(true);
      getTrxnData(id);
    }
  };

  const getTrxnData = async (selectedTransaction: string) => {
    if (selectedTab === "Online") {
      setLoading(true);
      try {
        const req = await getTransactionData(selectedTransaction);
        const res = await req?.data;
        if (res) {
          setTrxnData(res);
        }
      } catch (error) {
        console.error("Error while getting transaction data:", error);
      } finally {
        setLoading(false);
      }
    } else if (selectedTab === "Convera") {
      const data = transactions?.find(
        (selectData: any) => selectData?.converaReferenceId == selectedTransaction
      );
      setTrxnData(data);
    } else {
      const data = transactions?.find(
        (selectData: any) => selectData?.id == selectedTransaction
      );
      setTrxnData(data);
    }
  };

  return (
    <div id="New-History-Card">
      <ToastContainer position="top-center" />
      <div
        id="History-Card-Accordion"
        className={`${selectedTab !== "Online" ? "border border-[#E8E8E8]" : " "
          }`}
      >
        <div
          id="History-Page-Transaction-list"
          className={`${selectedTab !== "Online" ? "" : " px-0 w-full "}`}
        >
          <div id="History-Page-Transaction">
            {transactions.length > 0 &&
              transactions
                ?.slice(0, pagination.size || 10)
                ?.map((transactionList: any, index: number) => {
                  return (
                    <div
                      className={`${selectedTab !== "Online"
                        ? "odd:bg-white even:bg-[#F8F8FC] p-2 w-full"
                        : "my-2 bg-[#F2F2F2] p-2 w-full rounded-md"
                        }`}
                      key={index}
                    >
                      <NewHistoryCardTransaction
                        transactionsList={transactionList}
                        isOpen={isOpen}
                        selectedTransaction={selectedTransaction}
                        selectedTab={selectedTab as TabKeys}
                        handleAccordionClick={handleAccordionClick}
                        loading={loading}
                        setLoading={setLoading}
                      />
                      <div
                        className={`transition-all duration-500 ease-in-out overflow-auto ${isOpen &&
                          (selectedTransaction === transactionList?.converaReferenceId ||
                            selectedTransaction === transactionList?.transactionNumber ||
                            selectedTransaction == transactionList?.id)
                          ? isDownloadDocxButtonClicked || isShareButtonClicked ? "min-h-[700px] opacity-100" : "max-h-[1000px] opacity-100"
                          : "max-h-0 opacity-0"
                          }`}
                      >
                        {!loading && (
                          <div id="History-page-transaction-data" className="p-2 rounded-md">
                            <NewHistoryCardTransactionData
                              trxnData={trxnData}
                              selectedTab={selectedTab}
                              selectedTransaction={selectedTransaction}
                              setIsModalOpen={setIsModalOpen}
                              setIsCancelModalOpen={setIsCancelModalOpen}
                              isDownloadDocxButtonClicked={isDownloadDocxButtonClicked}
                              setIsDownloadDocxButtonClicked={setIsDownloadDocxButtonClicked}
                              isShareButtonClicked={isShareButtonClicked}
                              setIsShareButtonClicked={setIsShareButtonClicked}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  )
                }
                )}
          </div>
        </div>
      </div>
    </div>
  );
};

// detail component showing basic user information.
export const DetailCard: React.FC<DetailsMultipleDataProps> = ({
  title,
  details,
  data,
}) => {
  return (
    <div className="col-span-1 bg-[#F5F5F5] h-full p-4 rounded-md">
      <div className="flex flex-col">
        <h3 className="font-bold text-xs">{title}</h3>
        <div className="pt-2">
          {data
            ? data.map(
              (item, index) =>
                item?.show && (
                  <div key={index} className="pb-4">
                    <h4 className="font-bold text-xs">{item.title}</h4>
                    {item.details.map((detail, index) => (
                      <p
                        key={index}
                        className="text-sm leading-8 text-[#646464]"
                      >
                        {detail.label ? detail.label + ":" : ""}{" "}
                        <span
                          className={`${detail?.important && "font-semibold text-black"
                            }`}
                        >
                          {detail.value ? detail.value : "NA"}
                        </span>
                      </p>
                    ))}
                  </div>
                )
            )
            : details &&
            details.map((detail, index) =>
              detail?.show && (detail?.label ? (
                <p
                  key={index}
                  className="text-sm pt-2 leading-8 text-[#646464]"
                >
                  {detail.label ? detail.label + ":" : ""}{" "}
                  <span
                    className={`${detail?.important && "font-semibold text-black"
                      }`}
                  >
                    {detail.value ? detail.value : "NA"}
                  </span>
                </p>
              ) : (
                <p key={index} className="text-sm leading-8">
                  {detail.value ? detail.value : "NA"}
                </p>
              ))
            )}
        </div>
      </div>
    </div>
  );
};

// 3 details card showing user details
export const TransactionDataGrids: React.FC<TransactionExtensionProps> = ({
  trxnData,
}) => {
  const [utrNumber, setUtrNumber] = useState<string>();
  const [, setEsignModal] = useRecoilState(historyPageEsignModal);
  const [wait, setWait] = useState<boolean>(false);
  const [utrSubmittedMsg, setUtrSubmittedMsg] = useState<boolean>(false);
  const selectedTransaction = useRecoilValue(historyPageSelectedTransaction);
  const [comments, setComments] = useState<CommentsProps[]>([]);
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const [showInfo, setShowInfo] = useState<boolean>(false);
  const [isUploaded, setIsUploaded] = React.useState(false);
  const [uploadDocErrMsg, setUploadDocErrMsg] = useState("");

  const fileInputRef = React.useRef<HTMLInputElement | null>(null);
  const [isLinkedCopied, setIsLinkedCopied] = React.useState<boolean>(false);

  useEffect(() => {
    if (utrSubmittedMsg) {
      const timeoutId = setTimeout(() => setUtrSubmittedMsg(false), 3500);
      return () => clearTimeout(timeoutId);
    }
  }, [utrSubmittedMsg]);


  useEffect(() => {
    selectedTransaction && getComment();
  }, [selectedTransaction]);

  useEffect(() => {
    if (trxnData.paymentConfirmationManuallyUploadedByUser === true) {
      setIsUploaded(true)
    }
  }, [trxnData.paymentConfirmationManuallyUploadedByUser])

  const getComment = async () => {
    getTransactionRemarks(currentUser, selectedTransaction)
      .then((res) => {
        setComments(res?.data?.remarkList);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // const handleVerifyPayment = async (value: string) => {
  //   if (utrNumber === "") {
  //     toast.error(
  //       `${value === "paymentID" ? "Payment ID" : "UTR Number"} is required`
  //     );
  //   } else {
  //     setWait(true);
  //     const data = {
  //       utr_num: utrNumber,
  //       transaction_num: selectedTransaction,
  //     };
  //     try {
  //       const req = await postNewUTRNum(data);
  //       const res = await req?.data;
  //       if (res) {
  //         toast.success(res?.Message || "Successfully submitted.");
  //         setUtrNumber("");
  //         handleUtrMessage();
  //       }
  //     } catch (error) {
  //       toast.error("Please check id or contact admin.");
  //     } finally {
  //       setWait(false);
  //     }
  //   }
  // };

  const handleUtrMessage = () => {
    setUtrSubmittedMsg(true);
  };

  const handleEsignClick = (modalName: string) => {
    setEsignModal(() => ({ isModalOpen: true, modalName }));
  };

  const handleUploadButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleDocRemoval = () => {
    setIsUploaded(false);
  };

  const newDate = new Date(
    trxnData?.remitterAndBeneDetails?.remitterDob
  ).toLocaleDateString();
  const commentStatus = ["IN_TRANSIT", "COMPLETED"];
  const dontShowComments = commentStatus?.includes(trxnData?.status);

  const handleUploadDocs = (e: any, txnNo: string) => {
    setIsUploaded(false);
    const fileData = e?.target?.files?.[0];
    if (fileData) {
      let data = new FormData();
      data.append("file", fileData);
      data.append("doc_type", "Payment_Confirmation");
      uploadDocs(currentUser, txnNo, data)
        .then((response: any) => {
          if (response?.data?.success) {
            toast.success("Document uploaded successfully.");
            setIsUploaded(true);
            if (fileInputRef.current) {
              fileInputRef.current.value = "";
            }
          } else {
            setUploadDocErrMsg(response?.response?.data?.error?.type);
          }
        })
        .catch((error) => {
          setUploadDocErrMsg(error?.response?.data?.error?.type);
        });
    }
  };

  const copyLink = (a2Link: string) => {
    setIsLinkedCopied(true);
    navigator.clipboard.writeText(a2Link);
    setTimeout(() => {
      setIsLinkedCopied(false);
    }, 3000);
  };


  const bgColor =
    uploadDocErrMsg !== ""
      ? "bg-[#F70408] text-[#FFF]"
      : (isUploaded && trxnData.paymentConfirmationManuallyUploadedByUser) || isUploaded
        ? "bg-[#37C820] text-[#FFF]"
        : !isUploaded && trxnData.paymentConfirmationManuallyUploadedByUser
          ? "bg-[#37C820] text-[#FFF]"
          : "bg-[#37C820] text-[#FFF]";

  const transactionData = [
    {
      title: "Remitter Details",
      show: true,
      details: [
        {
          label: "Name",
          value: trxnData?.remitterAndBeneDetails?.remitterName,
          important: true,
          show: true,
        },
        { label: "DOB", value: newDate, important: true },
        // { label: "Gender", value: trxnData?.remitterAndBeneDetails?. },
        {
          label: "E-mail",
          value: trxnData?.remitterAndBeneDetails?.remitterEmail,
          important: true,
          show: true,
        },
        {
          label: "Phone",
          value: trxnData?.remitterAndBeneDetails?.remitterPhoneNumber,
          important: true,
          show: true,
        },
        {
          label: "A2 Form Status",
          value: (
            <span
              className={`${!trxnData?.remitterAndBeneDetails?.hasRemitterSigned &&
                "text-[#FF0000]"
                }`}
            >
              {trxnData?.remitterAndBeneDetails?.hasRemitterSigned
                ? "Signed"
                : "Not Signed"}
            </span>
          ),
          show: !trxnData?.remitterAndBeneDetails?.hasRemitterSigned,
        },
        {
          label: !trxnData?.remitterAndBeneDetails?.hasRemitterSigned
            ? "Send link on"
            : "",
          value: !trxnData?.remitterAndBeneDetails?.hasRemitterSigned ? (
            <>
              <button
                onClick={() => handleEsignClick("email")}
                className="text-[#0F5BF1] font-semibold"
              >
                email
              </button>{" "}
              or{" "}
              <button
                onClick={() => handleEsignClick("mobile")}
                className="text-[#0F5BF1] font-semibold"
              >
                mobile
              </button>
              {trxnData?.remitterAndBeneDetails?.link && (
                <button
                  onClick={() =>
                    trxnData?.remitterAndBeneDetails?.link &&
                    copyLink(trxnData?.remitterAndBeneDetails?.link)
                  }
                  className="flex justify-center items-center"
                >
                  <span
                    className={`text-xs font-semibold ${isLinkedCopied ? "text-green-500" : "text-[#0F5BF1]"
                      }`}
                    style={{ transitionDuration: "300ms" }}
                  >
                    {isLinkedCopied ? "Link Copied" : "Copy Link"}
                  </span>
                  <img className="pl-2" src={CopyLink} alt="copy-link" />
                </button>
              )}
            </>
          ) : (
            ""
          ),
          show: !trxnData?.remitterAndBeneDetails?.hasRemitterSigned,
        },
      ],
    },
    [
      {
        title: "Recipient Details",
        show: true,
        details: [
          {
            label: "Name",
            value: trxnData?.remitterAndBeneDetails?.beneficiaryName,
            important: true,
          },
          {
            label: "Relationship",
            value: trxnData?.remitterAndBeneDetails?.beneficiaryRelationShip,
            important: true,
          },
          {
            label: "Country of Residence",
            value:
              trxnData?.remitterAndBeneDetails?.beneficiaryCountryOfResidence,
            important: true,
          },
        ],
      },
      {
        title: "Recipient Bank Details",
        show: true,
        details: [
          {
            label: "Account No",
            value:
              trxnData?.remitterAndBeneDetails?.beneficiaryBankAccountNumber,
            important: true,
          },
          {
            label: "Bank",
            value: trxnData?.remitterAndBeneDetails?.beneficiaryBankName,
            important: true,
          },
          {
            label: "Swift Code",
            value: trxnData?.remitterAndBeneDetails?.swiftCode,
            important: true,
          },
          {
            label: "LAN Number",
            value: trxnData?.declarationDetails?.lanNumber,
            important: true,
          },
        ],
      },
    ],
    [
      {
        title: "Payment Details",
        show: true,
        details: [
          {
            label: "Amount Sent",
            value: trxnData?.paymentBreakUp?.amountSent?.toLocaleString("en-IN"),
            important: true,
          },
        ],
      },
      {
        title: "Fees and Taxess",
        show: true,
        details: [
          {
            label: "Bank rate",
            value: trxnData?.paymentBreakUp?.ibr?.toFixed(2),
            important: true,
          },
          {
            label: "Vendor Rate",
            value:
              trxnData?.paymentBreakUp?.rateApplied -
              trxnData?.paymentBreakUp?.vendorMargin,
            important: true,
          },
          {
            label: "TCS",
            value:
              trxnData?.paymentBreakUp?.tcs?.toLocaleString("en-IN") +
              " " +
              trxnData?.paymentBreakUp?.sourceCurrency,
            important: true,
          },
          {
            label: "Vendor fees",
            value: trxnData?.paymentBreakUp?.convenienceFee,
            important: true,
          },
          {
            label: "Nostro Charges",
            value: trxnData?.paymentBreakUp?.nostroCharges?.toLocaleString("en-IN"),
            important: true,
          },
          {
            label: "Total Payment",
            value: trxnData?.paymentBreakUp?.totalPay?.toLocaleString("en-IN"),
            important: true,
          },
          {
            label: "They receive",
            value: trxnData?.paymentBreakUp?.theyReceive?.toLocaleString("en-US"),
            important: true,
          },
        ],
      },
    ],
    [
      {
        title: "Transfer Details",
        show: true,
        details: [
          {
            label: "Mode of payment",
            value: trxnData?.paymentDetails?.modeOfPayment,
            important: true,
          },
          {
            label: "Country of Residence",
            value:
              trxnData?.remitterAndBeneDetails?.beneficiaryCountryOfResidence,
            important: true,
          },
          {
            label: "Source of Funds",
            value: trxnData?.otherDetails?.sourceOfIncome,
            important: true,
          },
          {
            label: "",
            value: (
              <div className="flex flex-col items-start gap-2 mt-9 relative">
                <div className="flex items-center gap-2 ">
                  <p className="text-xs font-bold text-black">
                    Proof of payment (Optional)
                  </p>
                  <div
                    onMouseEnter={() => setShowInfo(true)}
                    onMouseLeave={() => setShowInfo(false)}
                  >
                    <InfoIcon fillColor="#8D8D8D" />
                  </div>
                </div>
                <div className="flex items-center gap-1 w-full">
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*,application/pdf"
                    className="hidden"
                    onChange={(e) => {
                      handleUploadDocs(e, selectedTransaction);
                    }}
                  />
                  <Button
                    bgColor={
                      bgColor
                    }
                    className={
                      isUploaded ||
                        trxnData.paymentConfirmationManuallyUploadedByUser ===
                        true
                        ? "relative  hidden items-center justify-center lg:flex rounded cursor-pointer p-4 h-full max-h-[25px]"
                        : "relative  hidden items-center justify-center lg:flex rounded cursor-pointer p-4 h-full max-h-[25px] disabled:cursor-not-allowed"
                    }
                    onClickHandler={() => {
                      handleUploadButtonClick();
                      uploadDocErrMsg !== "" && setUploadDocErrMsg("");

                    }}
                    disabled={trxnData.status !== "AWAITING_PAYMENT"}
                  >
                    <div className="flex items-center justify-center">
                      {isUploaded && trxnData.paymentConfirmationManuallyUploadedByUser || isUploaded ? (
                        <span className="font-semibold">Uploaded</span>
                      ) : !isUploaded && trxnData.paymentConfirmationManuallyUploadedByUser ? (
                        <span className="font-semibold">Upload</span>
                      ) : (
                        <span className="font-semibold">Upload</span>
                      )}
                    </div>
                  </Button>
                  <div
                    className={
                      trxnData.status === "AWAITING_PAYMENT"
                        ? "cursor-pointer"
                        : "cursor-not-allowed"
                    }
                    onClick={() => handleDocRemoval()}
                  >
                    <img src={refreshIcon} alt="" width={24} height={24} />
                  </div>
                </div>
                {uploadDocErrMsg !== "" && (
                  <ErrorField errorMessage={uploadDocErrMsg} />
                )}
                {showInfo === true && (
                  <div className="bg-grey-200 text-white-100 absolute left-[22%] -top-11 p-1 w-full">
                    Upload payment screenshot or bank statement
                  </div>
                )}
              </div>
            ),
          },
        ],
      },
      {
        title: "Comments:",
        show: !dontShowComments && comments?.length > 0 ? true : false,
        details: [
          {
            label: "",
            value: comments && comments.length > 0 && (
              Array.isArray(comments[comments.length - 1]?.remark) ? (
                <div>
                  {comments[comments.length - 1]?.remark.map((r: string, idx: number, arr: string[]) => (
                    <p key={idx}>
                      {r}{idx < arr.length - 1 ? "," : ""}
                    </p>
                  ))}
                </div>
              ) : (
                <p>{comments[comments.length - 1]?.remark}</p>
              )
            ),
            important: false,
          },
        ],
      },
    ],
  ];
  return (
    <div
      id="transaction-data-grids"
      className="grid sm:grid-cols-1 grid-cols-2 md:grid-cols-4 gap-6 min-h-full p-2 w-full"
    >
      {transactionData.map((data, index) => {
        if (Array.isArray(data)) {
          return <DetailCard key={index} data={data} />;
        } else {
          return (
            <DetailCard key={index} title={data.title} details={data.details} />
          );
        }
      })}
    </div>
  );
};

// download options
export const renderDownloadOptions = (
  trxnDocs: TransactionDocsProps,
  downloadingItem: { isLoading: boolean; docName: string },
  handleKYCOtherDocsDownload: (doc: string, docName: string) => void
) => {
  return (
    <div className="absolute shadow-md bg-white rounded-b-lg p-2 mt-[2.7rem] min-h-28 text-sm overflow-y-scroll z-10 noscrollbar w-fit scrollbar scrollbar-track scrollbar-thumb scrollbar-hover">
      {trxnDocs.map((docs) => (
        <button
          onClick={() =>
            handleKYCOtherDocsDownload(docs?.docPath, docs?.docName)
          }
          key={docs?.idDoc}
          className={`p-2 px-4 flex focus:bg-[#383E4708] items-center justify-start ${downloadingItem?.isLoading &&
            downloadingItem?.docName === docs?.docName &&
            "cursor-wait"
            }`}
          disabled={
            downloadingItem?.isLoading &&
            downloadingItem?.docName === docs?.docName
          }
        >
          <img
            src={DownwardArrow}
            className="px-2"
            alt="Download option icon"
          />
          {docs?.docName.replace("_", " ")}
        </button>
      ))}
    </div>
  );
};

// Share Option
// { label: "Receipt", value: "receipt" },
export const RenderShareOptions: React.FC<{
  selectedTransaction: string;
  userKey: string;
  trxnStatus: string;
  transactionDocsList: TransactionDocsProps;
}> = ({ selectedTransaction, userKey, trxnStatus, transactionDocsList }) => {
  const [selectedValue, setSelectedValue] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [downloadWait, setDownloadingWait] = useState<{
    document: string;
    status: boolean;
  }>();
  const docsList = [
    { label: "Transaction Advise", value: "receipt", customStatus: "" },
    { label: "A2 Form", value: "a2Form", customStatus: "" },
    // { label: "Transaction Invoice", value: "Txn_Invoice", customStatus: "" },

  ];

  const docList1 = transactionDocsList
    ?.filter(
      (docx) =>
        docx?.docName === "Swift Copy" || docx?.docName.startsWith("TCS")
    )
    .map((docx) => {
      return {
        label: docx?.docName,
        value: docx?.docName.replace(" ", ""),
        docPath: docx?.docPath,
        customStatus: "COMPLETED",
      };
    });

  const handleCheckboxChange = (value: string) => {
    setSelectedValue((prevSelected) =>
      prevSelected.includes(value)
        ? prevSelected.filter((item) => item !== value)
        : [...prevSelected, value]
    );
  };

  const currentUserString = localStorage.getItem("currentUser") || "";
  let currentUser: User = {};

  if (currentUserString) {
    try {
      currentUser = JSON.parse(currentUserString);
    } catch (error) {
      console.error("Error parsing currentUser from sessionStorage:", error);
    }
  }

  const vendorKey = currentUser?.vendor_key || "";

  const handleTransDocs = async (docPath: string, value: string) => {
    setDownloadingWait({ document: value, status: true });
    try {
      const req = await getTransactionDocx({
        vendorKey,
        selectedTransaction,
        docPath,
      });
      const res = req?.data;
      if (res) {
        window.open(res.url);
      }
    } catch (error) {
      console.error("Failed to download document.", error);
    } finally {
      setDownloadingWait({ document: "", status: false });
    }
  };

  const handleDownloadClick = (doc: {
    label: string;
    value: string;
    docPath: string;
    customStatus: string;
  }) => {
    if (trxnStatus === "COMPLETED" && doc?.value !== "Txn_Invoice") {
      handleTransDocs(doc?.docPath, doc?.value);
    }
    // else if (doc?.value === "Txn_Invoice") {

    // }
    return handleValueChange(doc?.value);
  };

  const handleValueChange = async (value: string) => {
    try {
      setDownloadingWait({ document: value, status: true });
      const req = await downloadDocumentHistoryPage({
        vendorKey,
        value,
        selectedTransaction,
      });
      const res = req?.data;
      if (res) {
        downloadDocumentHistory(
          res,
          localStorage.getItem(`${selectedTransaction}_${value}.pdf`) || ""
        );
        setDownloadingWait({ document: value, status: false });
      }
    } catch (error) {
      console.error("Error while downloading documents:", error);
      toast.error("Failed to download document.!");
    } finally {
      setDownloadingWait({ document: "", status: false });
    }
  };

  const handleSubmit = async (mode: string) => {
    setLoading(true);
    const body = {
      selectedTransaction,
      userKey,
      mode: mode,
      selectedValue,
    };
    try {
      const req = await shareHistoryPageDocs(body);
      const res = await req?.data;
      if (res) {
        toast.success(`Document sent successfully on your registered ${mode}.`);
      }
    } catch (error: any) {
      const newError = error?.response?.data?.error?.type;
      console.error("Error", newError);
      toast.error(newError || "Something went wrong.!");
    } finally {
      setLoading(false);
    }
  };

  const filteredDocs =
    trxnStatus === "COMPLETED" ? [...docsList, ...docList1] : docsList;

  return (
    <div className="absolute shadow-md bg-white rounded-lg p-2 min-h-full text-sm overflow-y-scroll z-10 noscrollbar scrollbar scrollbar-track scrollbar-thumb min-w-[270px] scrollbar-hover text-nowrap w-full leading-7">
      {filteredDocs?.map((doc: any, index: number) => (
        <label
          key={index}
          className={`p-2 rounded-md flex justify-between items-center ${downloadWait?.status && "cursor-pointer"
            } ${selectedValue.includes(doc.value) && "bg-[#383E4708]"}`}
        >
          <div className="flex justify-start items-center">
            <input
              type="checkbox"
              checked={selectedValue.includes(doc.value)}
              onChange={() => handleCheckboxChange(doc.value)}
              className="mr-2"
            />
            <span>{doc.label}</span>
          </div>
          <button
            onClick={() => handleDownloadClick(doc)}
            className="disabled:cursor-wait"
            disabled={downloadWait?.status}
          >
            <img
              src={DownwardArrow}
              className="px-2 "
              alt="Download option icon"
            />
          </button>
        </label>
      ))}
      <div className="w-full">
        <span>Send documents on </span>
        <button
          className={`text-[#0F5BF1] font-semibold ${loading && "cursor-wait"}`}
          onClick={() => handleSubmit("email")}
        >
          Email
        </button>{" "}
        {/* or{" "}
        <button
          className={`text-[#0F5BF1] font-semibold ${loading && "cursor-wait"}`}
          onClick={() => handleSubmit("whatsapp")}
        >
          WhatsApp
        </button> */}
      </div>
    </div>
  );
};

// calculate remaining timing
const Timer: React.FC<TimerProps> = ({ initialRemainingTime }) => {
  const [remainingTime, setRemainingTime] = useState(initialRemainingTime);

  useEffect(() => {
    if (remainingTime <= 0) {
      return;
    }

    const intervalId = setInterval(() => {
      setRemainingTime((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [remainingTime]);

  const formatTime = (time: number) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  return <p className="timer">{formatTime(remainingTime)}</p>;
};

// component that showing main data of while clicking to extend trxn
export const NewHistoryCardTransactionData: React.FC<TransactionDataProps> = ({
  trxnData,
  selectedTransaction,
  setIsModalOpen,
  selectedTab,
  setIsCancelModalOpen,
  isDownloadDocxButtonClicked,
  setIsDownloadDocxButtonClicked,
  isShareButtonClicked,
  setIsShareButtonClicked,
}) => {


  const [, setTransactionNumber] = useRecoilState(transactionId);
  const [, setSelectedTransactionID] = useRecoilState(selectedTransactionID);
  const [, setTrxnRejectionStatus] = useRecoilState(
    selectedTransactionRejectionStatus
  );
  const dropdownDocsRef = useRef(null);
  const dropdownRef = useRef(null);
  const [downloadingItem, setDownloadingItem] = useState({
    isLoading: false,
    docName: "",
  });
  const navigate = useNavigate();
  useEffect(() => {
    trxnData?.detailedStatus?.toLowerCase()?.includes("reject")
      ? setTrxnRejectionStatus(true)
      : setTrxnRejectionStatus(false);
  }, [trxnData]);

  // useClickOutside(dropdownDocsRef, () => setIsDownloadDocxButtonClicked(false));
  // useClickOutside(dropdownRef, () => setIsShareButtonClicked(false));

  const status = trxnData?.status;

  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  const handleKYCOtherDocsDownload = async (doc: string, docName: string) => {
    try {
      setDownloadingItem({ docName, isLoading: true });

      const res = await downloadOtherKycDocx(
        currentUser,
        selectedTransaction,
        doc
      );
      const url = res?.data?.url;
      if (url) {
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Relationship_Proof.jpg");
        link.target = "_blank";
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: false,
            view: window,
          })
        );
      } else {
        toast.error("Failed to download file.!");
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setDownloadingItem({ docName: "", isLoading: false });
    }
  };

  if (selectedTab === "Online") {
    return (
      <div id="Transaction-Data-Main-Component" className="px-[4%]">
        <div id="Transaction-Data-status-line" className="p-2">
          <div className="">
            <Stepper
              key="Payment"
              numberOfSteps={4}
              steps={["Initiated", "Payment", "Processing", "Completed"]}
              activeStep={
                status === "AWAITING_PAYMENT"
                  ? 2
                  : status === "IN_TRANSIT"
                    ? 3
                    : status === "COMPLETED"
                      ? 4
                      : 1
              }
            />
          </div>
        </div>
        <div id="main-data-component" className="p-2 grid-cols-12 w-full">
          <TransactionDataGrids trxnData={trxnData} />
          <div id="transaction-button" className="p-2 grid-cols-12 w-full">
            <div
              id="transaction-data-grids"
              className="flex justify-between max-w-full flex-wrap"
            >
              <div className="flex justify-start relative w-full" ref={dropdownDocsRef}>
                <button
                  onClick={() =>
                    setIsDownloadDocxButtonClicked((prev) => !prev)
                  }
                  className="history-page-document-download-button relative flex items-center justify-between px-8 z-20"
                >
                  <img
                    src={Downlaod}
                    className="px-1 pr-3"
                    alt="Download Document Button"
                  />
                  Download Documents{" "}
                  <img
                    src={DownArrowWhite}
                    className="px-1.5 pl-3"
                    alt="Dropdown button"
                  />
                </button>
                {isDownloadDocxButtonClicked &&
                  renderDownloadOptions(
                    trxnData?.transactionDocs,
                    downloadingItem,
                    handleKYCOtherDocsDownload
                  )}
                <button
                  className="history-page-document-download-button"
                  onClick={() => setIsModalOpen(true)}
                >
                  Upload Documents
                </button>
                {status === "AWAITING_PAYMENT" && (
                  <button
                    className="history-page-document-download-button"
                    onClick={() => {
                      setTransactionNumber(selectedTransaction);
                      navigate("/payment", {
                        state: {
                          id: trxnData?.id,
                          from: "HistoryPage",
                          payAmount:
                            trxnData?.paymentBreakUp?.totalPay &&
                            JSON.stringify(trxnData?.paymentBreakUp?.totalPay),
                          // : JSON.stringify(advancePay),
                          purpose: trxnData?.otherDetails?.purposeCode,
                          userKey: trxnData?.kycDocs?.userKey,
                          vendorCode: trxnData?.declarationDetails?.vendorCode,
                        },
                      });
                    }}
                  >
                    Pay Now
                  </button>
                )}
                {trxnData?.otherDetails?.isCancelTransaction && (
                  <div className="relative min-w-48">
                    <button
                      onClick={() => {
                        setIsCancelModalOpen(true);
                        setSelectedTransactionID(trxnData?.id.toString());
                      }}
                      className="history-page-document-download-button flex items-center z-20 justify-center"
                    >
                      Cancel Transaction
                    </button>
                  </div>
                )}
                <div className="relative min-w-48" ref={dropdownRef}>
                  <button
                    onClick={() =>
                      setIsShareButtonClicked((prev) => !prev)
                    }
                    className="history-page-document-download-button flex items-center z-20 justify-center"
                  >
                    <img src={ShareWhite} className="px-1" alt="Share" />
                    Share
                  </button>
                  {isShareButtonClicked && (
                    <RenderShareOptions
                      selectedTransaction={selectedTransaction}
                      userKey={trxnData?.kycDocs?.userKey}
                      trxnStatus={trxnData?.status}
                      transactionDocsList={trxnData?.transactionDocs}
                    />
                  )}
                </div>
              </div>
              {trxnData?.remainingTime && (
                <div>
                  <p className="text-[#006EFF] text-sm flex">
                    Please complete your payment within:{" "}
                    <span className="text-[#EA2A2A] pl-2">
                      {<Timer initialRemainingTime={trxnData?.remainingTime} />}
                    </span>
                  </p>
                  <p className="text-sm">
                    Otherwise your transaction may be put on hold
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    const handlePanDownload = (docPath: string) => {
      getDownlaodPAN(docPath)
        .then((response: any) => {
          window.open(response?.data?.url);
        })
        .catch((error: any) => {
          toast.error(
            error.message || "Failed to get mhOpsRejected transactions count"
          );
        });
    };
    const expandedData = [
      {
        header: "Remitter PAN Number",
        show: selectedTab !== "Convera",
        data: trxnData?.panNumber || "N/A",
      },
      {
        header: "LAN Number",
        show: selectedTab !== "Convera",
        data: trxnData?.lanNumber || "N/A",
      },
      {
        header: "UTR Number",
        show: selectedTab !== "Convera",
        data: trxnData?.utr || "N/A",
      },
      {
        header: "Client Rate",
        show: selectedTab !== "Convera",
        data: trxnData?.clientRate || "N/A",
      },
      {
        header: "Booking Rate",
        show: selectedTab !== "Convera",
        data: trxnData?.bookingRate || "N/A",
      },
      {
        header: "Swift Copy",
        show: selectedTab === "Offline" && trxnData?.swiftDocId?.docPath && true,
        data: () => (
          <button
            onClick={() =>
              trxnData?.swiftDocId?.docPath &&
              handlePanDownload(trxnData?.swiftDocId?.docPath)
            }
          >
            <img src={DownloadCloud} />
          </button>
        ),
      },
      {
        header: "Invoice",
        show: selectedTab === "Travel Card" && trxnData?.invoiceDocId?.docPath && true,
        data: () => (
          <button
            onClick={() =>
              trxnData?.invoiceDocId?.docPath &&
              handlePanDownload(trxnData?.invoiceDocId?.docPath)
            }
          >
            <img src={DownloadCloud} />
          </button>
        ),
      },
      {
        header: "Card Number",
        show: selectedTab === "Travel Card",
        data: trxnData?.travelCard || "",
      },
      {
        header: "Remitter PAN Card",
        show: trxnData?.panDocId?.docPath && selectedTab !== "Convera",
        data: () => (
          <button
            onClick={() =>
              trxnData?.panDocId?.docPath &&
              handlePanDownload(trxnData?.panDocId?.docPath)
            }
          >
            <img src={DownloadCloud} />
          </button>
        ),
      },
      {
        header: "Recipient Name",
        show: selectedTab === "Convera",
        data: trxnData?.recipientName || "N/A",
      },
      {
        header: "Student Name",
        show: selectedTab === "Convera",
        data: trxnData?.studentName || "N/A",
      },
      {
        header: "Invoice No.",
        show: selectedTab === "Convera",
        data: trxnData?.invoiceNumber || "N/A",
      },
      {
        header: "Due Date",
        show: selectedTab === "Convera",
        data: getDate(trxnData?.dueDate) || "N/A",
      },
      {
        header: "Payment Instructions link",
        show: selectedTab === "Convera",
        data: () => (
          <button
            onClick={() =>
              window.open(`${trxnData?.downloadInstructionLink}`, "_blank")
            }
          >
            <img src={DownloadCloud} />
          </button>
        ),
      },
    ];
    return (
      <div className="w-full flex justify-between px-6 py-4 pb-0">
        {expandedData?.length > 0 &&
          expandedData?.map(
            (data, index) =>
              data?.show && (
                <div key={index}>
                  <h4 className="font-medium text-sm">{data?.header}</h4>
                  {typeof data?.data === "function" ? (
                    data?.data()
                  ) : (
                    <p className="font-normal text-sm text-[#5D5D5D]">
                      {data?.data}
                    </p>
                  )}
                </div>
              )
          )}
      </div>
    );
  }
};

export default NewHistoryCard;
